import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { head } from 'lodash';
import { Grid } from 'web-ui-components/lib/layout/grids';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import { VerticalReviewTable } from 'web-ui-components/lib/layout/tables';
import withContent from '../../../containers/withContent';
import paymentDetailsContent, { contentPropTypes } from './RepeatingPaymentDetails.content';
import { formatDate, formatLongDateTime } from '../../../utils/dateUtils';
import { formatAccountDetails } from '../../../utils/accountUtils';
import { verificationPropTypes } from '../../../states/payments/propTypes';
import { paymentFrequencyLabelMap } from '../../../config/index';
import { formatAmount } from '../../../utils/numberUtils';

const RepeatingPaymentDetails = ({ content, payment }) => {
	const {
		title,
		fromLabel,
		toLabel,
		amountLabel,
		refLabel,
		startDateLabel,
		frequencyLabel,
		stopPaymentLabel,
		createdByLabel,
		createdOnLabel,
		stopsWhenItIsCancelled,
	} = content;

	const { created_timestamp } = payment;
	const { creator_name, reference, start_date, end_date, frequency, amount, to_account, from_account } = head(
		payment.payments
	);

	const stopsWhen = end_date ? formatDate(end_date) : stopsWhenItIsCancelled;
	const frequencyCell = frequency in paymentFrequencyLabelMap ? paymentFrequencyLabelMap[frequency].label : frequency;

	const repeatingPaymentData = [
		{ headerText: fromLabel, cellText: formatAccountDetails(from_account) },
		{ headerText: toLabel, cellText: formatAccountDetails(to_account) },
		{ headerText: amountLabel, cellText: formatAmount(amount) },
		{ headerText: refLabel, cellText: reference },
		{ headerText: startDateLabel, cellText: formatDate(start_date) },
		{ headerText: frequencyLabel, cellText: frequencyCell },
		{ headerText: stopPaymentLabel, cellText: stopsWhen },
		{ headerText: createdByLabel, cellText: creator_name },
		{ ...(created_timestamp ? { headerText: createdOnLabel, cellText: formatLongDateTime(created_timestamp) } : []) },
	];

	return (
		<Grid.TwoThirds>
			<SectionHeading>{title}</SectionHeading>
			<VerticalReviewTable data={repeatingPaymentData} />
		</Grid.TwoThirds>
	);
};

RepeatingPaymentDetails.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	payment: PropTypes.shape(verificationPropTypes),
};

const contentWrapper = withContent({ content: paymentDetailsContent });
export default connect()(contentWrapper(RepeatingPaymentDetails));
export const ConnectWrapper = connect()(RepeatingPaymentDetails);
